import React from 'react';
import PageLayout from '../components/PageLayout';
import FeedbackForm from '../components/FeedbackForm';
import EventInfoCard from '../components/EventInfoCard';
import { CURRENT_FEEDBACK_EVENT } from '../config/events';

const FeedbackPage = () => (
  <PageLayout>
    <EventInfoCard event={CURRENT_FEEDBACK_EVENT} />
    <FeedbackForm />
  </PageLayout>
);

export default FeedbackPage;